import React from 'react';
import PropTypes from 'prop-types';
import LabelInput from 'library/components/unstyled-input';

import 'apps/pathways/styles/start/main.scss';

class SocialMedia extends React.PureComponent {
  render() {
    const { onChange, social_type, social_url, active } = this.props;
    return (
      <div className="experiences-form-container">
        <section>
          <label htmlFor="social_type">
            Social Type
            <select
              aria-label="social_type"
              aria-required="true"
              required={active}
              disabled={!active}
              onChange={onChange}
              value={social_type}
              name="social_type"
              id="social_type"
            >
              <option value="">--Select One--</option>
              <option value="twitter">Twitter</option>
              <option value="facebook">Facebook</option>
              <option value="gplus">Google+</option>
              <option value="linkedin">Linkedin</option>
              <option value="instagram">Instagram</option>
              <option value="other">Other</option>
            </select>
          </label>

          <LabelInput
            label="Social Media Url"
            disabled={!active}
            required={active}
            name="social_url"
            type="url"
            onChange={onChange}
            placeholder="Name"
            value={social_url}
          />
        </section>
      </div>
    );
  }
}

SocialMedia.propTypes = {
  onChange: PropTypes.func,
  social_type: PropTypes.string,
  social_url: PropTypes.string,
  active: PropTypes.bool,
};

export default SocialMedia;
